// @flow

import * as React from "react";

import AnimateHeight from "../atoms/AnimateHeight";
import Icon from "../atoms/Icon";

import { ReactForm, ReactFormField } from "@adrenalin/react-form";

type PropsType = {
    title: string | React.Node,
    subtitle: string | React.Node,
    defaultValue: any,
    small?: boolean,
    children?: string | React.Node,
    active?: boolean,
    isOpen?: boolean,
    setIsOpen?: () => void,
    formRef?: (instance: any) => void,
    onUpdate?: () => void,
};

const TicketAccordionForm = (props: PropsType): React.Node => {
    const [nativeIsOpen, nativeSetIsOpen] = React.useState(props.active);

    const isOpen = props.isOpen != null ? props.isOpen : nativeIsOpen;
    const setIsOpen =
        props.setIsOpen != null ? props.setIsOpen : nativeSetIsOpen;

    const handleTitleClick = e => {
        setIsOpen(a => !a);
        e.preventDefault();
    };

    return (
        <div
            className={`accordion accordion-form ${
                props.small ? "accordion--small" : ""
            } ${isOpen ? "accordion--active" : ""}`}
        >
            <button className="accordion__title" onClick={handleTitleClick}>
                <div className="accordion__title__inner__wrapper">
                    <h4 className="accordion__title__inner heading-4">
                        {props.title}
                    </h4>
                    <div
                        className={`accordion__title__inner__subtitle${
                            !props.subtitle
                                ? " accordion__title__inner__subtitle--empty"
                                : ""
                        }`}
                    >
                        {props.subtitle}&nbsp;
                    </div>
                </div>
                {props.small ? (
                    <Icon name={`${isOpen ? "chevron-up" : "chevron-down"}`} />
                ) : (
                    <Icon name={`${isOpen ? "minus" : "plus"}`} />
                )}
            </button>
            <div className="accordion__content">
                <AnimateHeight
                    duration={500}
                    hideOverflow
                    height={isOpen ? null : 0}
                >
                    <div
                        style={{
                            transition: "300ms ease all",
                            opacity: isOpen ? 1 : 0,
                        }}
                    >
                        <div className="accordion__content__inner">
                            <ReactForm
                                ref={props?.formRef}
                                onUpdate={props.onUpdate}
                                validators={[
                                    {
                                        ID: "zeroOrGreaterThan",
                                        validate: (input: HTMLInputElement) => {
                                            const value = parseFloat(
                                                input.value
                                            );
                                            return value === 0 || value >= 1;
                                        },
                                        error: "Please enter a value of $0 or greater than $1.",
                                    },
                                    {
                                        ID: "dateNotEarlierThan",
                                        validate: (
                                            input,
                                            validatorArguement,
                                            stateInputs
                                        ) => {
                                            let valid = false;
                                            stateInputs.forEach(stateInput => {
                                                // check matching state input to test against
                                                if (
                                                    stateInput.name ===
                                                    validatorArguement
                                                ) {
                                                    // handle date types
                                                    const stateInputDate =
                                                        Date.parse(
                                                            stateInput.value
                                                        );
                                                    const inputDate =
                                                        Date.parse(input.value);

                                                    if (
                                                        Number.isNaN(
                                                            inputDate
                                                        ) ||
                                                        Number.isNaN(
                                                            stateInputDate
                                                        )
                                                    ) {
                                                        valid = false;
                                                    } else {
                                                        valid =
                                                            inputDate >
                                                            stateInputDate;
                                                    }
                                                }
                                            });
                                            return valid;
                                        },
                                        error: "The &#39Available to&#39 date should not be the same or earlier than the &#39Available from&#39 date.",
                                    },
                                ]}
                            >
                                <ReactFormField
                                    type="text"
                                    className="hidden"
                                    name="id"
                                    id="id"
                                    value={props.defaultValue.id}
                                />
                                <ReactFormField
                                    type="number"
                                    name="qty"
                                    id="qty"
                                    label="Qty"
                                    placeholder=""
                                    min="0"
                                    required={true}
                                    defaultValue={props.defaultValue.qty?.toString()}
                                />
                                <ReactFormField
                                    type="number"
                                    name="price"
                                    id="price"
                                    label="Price"
                                    placeholder="Enter $0 or more than $1"
                                    className="has-placeholder is-focused no-controls"
                                    step="0.01"
                                    min="0"
                                    required={true}
                                    validators={["zeroOrGreaterThan"]}
                                    defaultValue={props.defaultValue.price}
                                />
                                <ReactFormField
                                    type="datetime-local"
                                    name="available_from"
                                    id="availableFrom"
                                    label="Available from"
                                    placeholder=""
                                    className="has-placeholder is-focused"
                                    required={true}
                                    defaultValue={
                                        props.defaultValue.available_from
                                    }
                                />
                                <ReactFormField
                                    type="datetime-local"
                                    name="available_until"
                                    id="availableTo"
                                    label="Available to"
                                    placeholder=""
                                    className="has-placeholder is-focused"
                                    required={true}
                                    validators={[
                                        "dateNotEarlierThan:available_from",
                                    ]}
                                    defaultValue={
                                        props.defaultValue.available_until
                                    }
                                />
                            </ReactForm>
                        </div>
                    </div>
                </AnimateHeight>
            </div>
        </div>
    );
};

export default TicketAccordionForm;
